import type { ITheme } from '@acsbe/ui';
import type { StripeElementsOptions } from '@stripe/stripe-js';

import { useTheme } from 'styled-components';

export function useStripeAppearance(): Readonly<
  StripeElementsOptions['appearance']
> {
  const theme = useTheme() as ITheme;

  return {
    theme: 'stripe',
    variables: {
      colorTextPlaceholder: theme.palette.scales.disabled.text.element,
      colorDanger: theme.palette.scales.danger.text.static,
    },
    rules: {
      '.Label': {
        marginBottom: '10px',
        color: theme.palette.scales.base.text.static,
        fontSize: '16px',
        fontFamily: 'Circular,sans-serif',
        lineHeight: '1.25',
        cursor: 'pointer !important',
      },
      '.Input': {
        color: theme.palette.scales.base.text.alt,
        fontSize: '15px',
        border: `2px solid ${theme.palette.scales.base.border.element}`,
        borderRadius: '8px',
        padding: '9.4px 20px',
      },
      '.Input:hover': {
        borderColor: `${theme.palette.scales.disabled.text.element}`,
      },
      '.Input:focus': {
        borderColor: '#136EF8',
        boxShadow: 'none',
      },
      '.Input:hover:focus': {
        borderColor: '#136EF8',
      },
      '.Input--invalid': {
        boxShadow: 'none',
      },
      '.Error': {
        width: '100%',
        marginTop: '10px',
        fontWeight: '400',
        fontSize: '15px',
        color: theme.palette.scales.danger.text.static,
      },
    },
  } as const;
}
